import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'users',
    name: 'manage.company.users',
    meta: { companyTab: 'user' },
    redirect: to => ({ name: 'manage.company.users.list', params: to.params }),
    children: [
      { path: '', name: 'manage.company.users.list', component: () => import('@/views/control-panel/manage/companies/company/UsersList.vue') },
      { path: 'create', name: 'manage.company.users.create', component: () => import('@/views/control-panel/manage/users/Create.vue') },
      {
        path: ':user',
        component: () => import('@/views/control-panel/manage/users/User.vue'),
        children: [
          { path: 'edit', name: 'manage.company.user.edit', component: () => import('@/views/control-panel/manage/users/user/Edit.vue') },
        ],
      },
    ],
  },
  {
    path: 'projects',
    name: 'manage.company.projects',
    meta: { companyTab: 'project' },
    redirect: to => ({ name: 'manage.company.projects.list', params: to.params }),
    children: [
      { path: '', name: 'manage.company.projects.list', component: () => import('@/views/control-panel/manage/companies/company/ProjectsList.vue') },
      { path: 'create', name: 'manage.company.projects.create', component: () => import('@/views/control-panel/projects/Create.vue') },
    ],
  },
  {
    path: 'settings',
    name: 'manage.company.settings',
    meta: { companyTab: 'setting' },
    component: () => import('@/views/control-panel/manage/companies/company/Edit.vue'),
  },
]

export default routes
